module.exports = __webpack_public_path__ + "img/mobile-cloud.c1e0a25a.png";